<div class="itemContainer">
  <div class="headline" style=" display: inline-flex;  margin: 20px;  width: 50vw;  justify-content: space-between;">
    <h3>{{ category.name }}</h3>



    <form [formGroup]="form" style="margin: 10px;">
      <mat-checkbox labelPosition="before" formControlName="filterOption">
        Filter Option
      </mat-checkbox>
    </form>
  </div>
  <div class="button-bar" *ngIf="formChanged">
    <button matButton="elevated" class="green-confirm" (click)="save()">Save</button>
    <button matButton="elevated" color="warn" (click)="cancel()">Cancel</button>
  </div>
</div>